import { useContext } from 'react';

import { AuthContext } from '@/common/layouts';

export const useAuthState = () => {
  const authState = useContext(AuthContext);

  return {
    sessionUser: authState.sessionUser,
    isAuthed: authState.isAuthed,
    setSessionUser: authState.setSessionUser,
    setAuthingState: authState.setAuthingState,
    changeCurrentTeamId: authState.changeCurrentTeamId
  };
};
